import React, { Component } from 'react';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.js';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw/dist/leaflet.draw-src';
import 'leaflet-control-geocoder/dist/Control.Geocoder.js';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import MarkerIcon from '../../../assets/images/marker-icon-2x.png';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import MasterGeofenceDialogForm from '../MasterGeofence/DialogForm';
import MasterPoolDialogForm from '../MasterPool/DialogForm';
import MasterCustomerPointDialogForm from '../CustomerPoint/DialogForm';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  button: {
    margin: theme.spacing.unit,
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
});

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      geojsonPolygonState: '',
      centroidLatState: '',
      centroidLngState: '',
      coordinatesStr: '',
      drawnPolygon: this.props.drawnPolygon || {
        type: 'Feature',
        features: [],
      },
    };
  }

  componentDidMount() {

    // console.log('\n01 - Map Leaflet - componentDidMount() - drawnPolygon => \n\t Type Data \t : ', typeof this.props.drawnPolygon, "\n\t Value Data  : ", this.props.drawnPolygon, "\n");
    this.map = L.map('map', {
      center: [-2.721044, 116.62442],
      zoom: 5
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);

    // == [START] INI KODE SEARCH ADDRESS DI SIDEBAR MAP ==
    let marker; // Variable to store the marker

    const nominatimGeocoder = L.Control.Geocoder.nominatim({
      serviceUrl: 'https://nominatim.openstreetmap.org/',
    });

    L.Control.geocoder({
      position: 'topleft',
      title: 'Search Address',
      defaultMarkGeocode: false,
      geocoder: nominatimGeocoder,
    }).on('markgeocode', (e) => {
      var latlng = e.geocode.center;
      const customIcon = L.icon({
        iconUrl: MarkerIcon,
        iconSize: [30, 54],
        iconAnchor: [15, 54],
      });

      // Remove the previous marker if it exists
      if (marker) {
        this.map.removeLayer(marker);
      }

      marker = L.marker(latlng, { icon: customIcon }).addTo(this.map);

      const popup = L.popup({
        autoPan: false,
      }).setContent(e.geocode.name);

      customIcon.options.popupAnchor = [0, -54];

      marker.bindPopup(popup).openPopup();

      this.map.fitBounds(e.geocode.bbox);
    }).addTo(this.map);
    // == [END] INI KODE SEARCH ADDRESS DI SIDEBAR MAP ==

    // == [START] INI KODE DRAW POLYGON DI SIDEBAR MAP ==
    // Initialize the FeatureGroup to store editable layers
    const editableLayers = new L.FeatureGroup();
    this.map.addLayer(editableLayers);

    // Initialize the draw control and pass it the FeatureGroup of editable layers
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: editableLayers,
        poly: {
          allowIntersection: false
        }
      },
      draw: {
        polygon: true,
        polyline: false,
        rectangle: false,
        circle: false,
        circlemarker: false,
        marker: false
      }
    });
    this.map.addControl(drawControl);

    const storedDrawnPolygon = localStorage.getItem('drawnPolygon');
    // console.log('\n02 - Map Leaflet - componentDidMount() - storedDrawnPolygon => \n\t Type Data \t : ', typeof storedDrawnPolygon, "\n\t Value Data  : ", storedDrawnPolygon, "\n");

    // Setelah setState drawnPolygon
    if (storedDrawnPolygon) {
      try {
        const parsedDrawnPolygon = JSON.parse(storedDrawnPolygon);
    
        // console.log('\n03 - Map Leaflet - componentDidMount() - parsedDrawnPolygon => \n\t Type Data \t : ', typeof parsedDrawnPolygon, "\n\t Value Data  : ", parsedDrawnPolygon, "\n");
        // Check if parsedDrawnPolygon is a valid GeoJSON object
        // if (parsedDrawnPolygon && parsedDrawnPolygon.type === 'Feature') {
        if (parsedDrawnPolygon) {
          this.setState({ drawnPolygon: parsedDrawnPolygon });
          // console.log('\n04 - Map Leaflet - componentDidMount() - parsedDrawnPolygon => \n\t Type Data \t : ', typeof parsedDrawnPolygon, "\n\t Value Data  : ", parsedDrawnPolygon, "\n");
    
          this.drawnPolygonLayer = L.geoJSON(parsedDrawnPolygon, {
            onEachFeature: (feature, layer) => {
              editableLayers.addLayer(layer);
              const centroid = layer.getBounds().getCenter();
              const centroidLat = centroid.lat;
              const centroidLng = centroid.lng;
              // console.log('\n05 - Map Leaflet - componentDidMount() - feature => \n\t Type Data \t : ', typeof feature, "\n\t Value Data  : ", feature, "\n");
              // console.log('\n06 - Map Leaflet - componentDidMount() - layer => \n\t Type Data \t : ', typeof layer, "\n\t Value Data  : ", layer, "\n");
              // console.log('\n07 - Map Leaflet - componentDidMount() - parsedDrawnPolygon => \n\t Type Data \t : ', typeof parsedDrawnPolygon, "\n\t Value Data  : ", parsedDrawnPolygon, "\n");

              layer.on('ubah', (event) => {
                const wktFromGeoJSON = (feature) => {
                    if (feature.type === 'Polygon') {
                        const coordinates = feature.coordinates[0].map(coord => coord.join(' ')).join(',');
                        return `POLYGON((${coordinates}))`;
                    }
                    return null;
                };
            
                const editedLayer = event.target;
                const updatedGeoJSON = editedLayer.toGeoJSON();
                const updatedWKTString = wktFromGeoJSON(updatedGeoJSON.geometry);
                const updatedPolygonString = JSON.stringify(updatedGeoJSON);
            
                this.setState({ geojsonPolygonState: updatedWKTString, centroidLatState: centroidLat, centroidLngState: centroidLng, coordinatesStr: updatedWKTString, geojson: updatedGeoJSON});
                this.props.drawnPolygon(updatedPolygonString);
                this.props.closeMap('', updatedWKTString, centroidLat, centroidLng);
                // console.log('\n08 - Map Leaflet - componentDidMount() - editedLayer => \n\t Type Data \t : ', typeof editedLayer, "\n\t Value Data  : ", editedLayer, "\n");
                // console.log('\n09 - Map Leaflet - componentDidMount() - updatedGeoJSON => \n\t Type Data \t : ', typeof updatedGeoJSON, "\n\t Value Data  : ", updatedGeoJSON, "\n");
                // console.log('\n10 - Map Leaflet - componentDidMount() - updatedWKTString => \n\t Type Data \t : ', typeof updatedWKTString, "\n\t Value Data  : ", updatedWKTString, "\n");
                // console.log('\n11 - Map Leaflet - componentDidMount() - updatedPolygonString => \n\t Type Data \t : ', typeof updatedPolygonString, "\n\t Value Data  : ", updatedPolygonString, "\n");
            });
            
              // Set up an event listener for deletion
              layer.on('delete', (event) => {
                const editedLayer = event.target;
                // console.log('\n19 - Map Leaflet - componentDidMount() - event => \n\t Type Data \t : ', typeof event, "\n\t Value Data  : ", event, "\n");
                // console.log('\n20 - Map Leaflet - componentDidMount() - editedLayer => \n\t Type Data \t : ', typeof editedLayer, "\n\t Value Data  : ", editedLayer, "\n");
                layer.remove();
                localStorage.removeItem('drawnPolygon');
                this.props.drawnPolygon('deleted');
              });
            },
          });
          // console.log('\n12 - Map Leaflet - componentDidMount() - this.drawnPolygonLayer => \n\t Type Data \t : ', typeof this.drawnPolygonLayer, "\n\t Value Data  : ", this.drawnPolygonLayer, "\n");
    
          // Add the L.geoJSON layer to the map
          this.drawnPolygonLayer.addTo(this.map);
    
          // Pusatkan peta pada polygon yang ditambahkan
          this.map.fitBounds(this.drawnPolygonLayer.getBounds());
    
          // Add the L.geoJSON layer to editableLayers
          // editableLayers.addLayer(this.drawnPolygonLayer);
    
        } else {
          console.error('Invalid GeoJSON format in storedDrawnPolygon:', storedDrawnPolygon);
        }
      } catch (error) {
        console.error('Error parsing storedDrawnPolygon:', error);
      }
    }
    
    this.map.on(L.Draw.Event.CREATED, (e) => {
      const type = e.layerType;
      const layer = e.layer;

      if (type === 'marker') {
        layer.bindPopup('A popup!');
      }

      // console.log('\n13 - Map Leaflet - componentDidMount() - layer => \n\t Type Data \t : ', typeof layer, "\n\t Value Data  : ", layer, "\n");
      // console.log('\n14 - Map Leaflet - componentDidMount() - layer.toGeoJSON() => \n\t Type Data \t : ', typeof layer.toGeoJSON(), "\n\t Value Data  : ", layer.toGeoJSON(), "\n");
      this.props.drawnPolygon(JSON.stringify(layer.toGeoJSON()));
      editableLayers.addLayer(layer);
      // == [END] INI KODE DRAW POLYGON DI SIDEBAR MAP ==
      
      // == [START] Mengonversi geojson menjadi string WKT ==
      const geojson = layer.toGeoJSON();
      const geojsonGeom = geojson.geometry;
      // console.log('\n15 - Map Leaflet - componentDidMount() - geojson => \n\t Type Data \t : ', typeof geojson, "\n\t Value Data  : ", geojson, "\n");
      // console.log('\n16 - Map Leaflet - componentDidMount() - geojsonGeom => \n\t Type Data \t : ', typeof geojsonGeom, "\n\t Value Data  : ", geojsonGeom, "\n");
      
      // Check if geojson has a geometry property
      if (geojsonGeom) {
        // console.log('\n17 - Map Leaflet - componentDidMount() - JSON.stringify(geojson) => \n\t Type Data \t : ', typeof JSON.stringify(geojson), "\n\t Value Data  : ", JSON.stringify(geojson), "\n");
        localStorage.setItem('drawnPolygon', JSON.stringify(geojson));
      } else {
        console.error('GeoJSON object does not have a valid geometry property');
      }

        const wktFromGeoJSON = (geojsonGeom) => {
            if (geojsonGeom.type === 'Polygon') {
            const coordinates = geojsonGeom.coordinates[0].map(coord => coord.join(' ')).join(',');
            return `POLYGON((${coordinates}))`;
          }
            return null;
        };
        
        const wktString = wktFromGeoJSON(geojsonGeom);
        // console.log('\n18 - Map Leaflet - componentDidMount() - wktString => \n\t Type Data \t : ', typeof wktString, "\n\t Value Data  : ", wktString, "\n");
        // == [END] Mengonversi geojson menjadi string WKT ==

        // == [START] INI KODE GET LAT LNG CENTROID ==
        const centroid = layer.getBounds().getCenter();
        const centroidLat = centroid.lat;
        const centroidLng = centroid.lng;
        // == [END] INI KODE GET LAT LNG CENTROID ==
        
        this.props.closeMap('', wktString, centroidLat, centroidLng);
        this.props.setCoordinates(wktString, centroidLat, centroidLng);
        this.setState(
          {
            geojsonPolygonState: wktString,
            centroidLatState: centroidLat,
            centroidLngState: centroidLng,
            coordinatesStr: wktString,
            geojson: geojson,
            drawnPolygon: layer.toGeoJSON(),
          },
          () => {
            this.props.onUpdateCoords(this.state.coordinatesStr);
          }
        );
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.drawnPolygon !== this.props.drawnPolygon) {
      const drawnPolygonString = JSON.stringify(this.props.drawnPolygon);

      // Update the state only if the drawnPolygon is different
      if (drawnPolygonString !== JSON.stringify(this.state.drawnPolygon)) {
        this.setState({ drawnPolygon: this.props.drawnPolygon });

        // Notify the parent component about the change
        this.props.onDrawnPolygonChange(this.props.drawnPolygon);
      }
    }
  }
  
  render() {
    const { classes } = this.props;
    const { drawnPolygon, geojsonPolygonState, centroidLatState, centroidLngState } = this.state;

    return (
      <div>
        <AppBar className="sticky-container">
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.flex}>
              Draw Polygon
            </Typography>
            <React.Fragment>
              <Button
                variant="contained"
                className="bg-white text-black"
                onClick={() => this.props.closeMap('batal', geojsonPolygonState, centroidLatState, centroidLngState)}
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
              {drawnPolygon && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.props.closeMap('save', geojsonPolygonState, centroidLatState, centroidLngState)}
                >
                  Save
                </Button>
              )}
            </React.Fragment>
          </Toolbar>
        </AppBar>
        <div id="map" style={{ height: '675px', marginTop: '60px' }}>
          <MasterGeofenceDialogForm 
              geojsonPolygon={this.state.geojsonPolygonState} 
              centroidlat={this.state.centroidLatState}
              centroidlng={this.state.centroidLngState}
              drawnPolygon={this.state.drawnPolygon}
          />
          <MasterPoolDialogForm 
              geojsonPolygon={this.state.geojsonPolygonState} 
              centroidlat={this.state.centroidLatState}
              centroidlng={this.state.centroidLngState}
          />
          <MasterCustomerPointDialogForm 
              geojsonPolygon={this.state.geojsonPolygonState} 
              centroidlat={this.state.centroidLatState}
              centroidlng={this.state.centroidLngState}
          />
        </div>
        {/* Dialog forms go here */}
      </div>
    );
  }
}

export default withStyles(styles)(Map);



// WEBPACK FOOTER //
// ./app/routes/MapLeaflet/index.js